<template>
    <div
        class="nav-auth-menu"
        data-test="nav-auth-menu">
        <DesktopSignInMenu
            data-test="nav-auth-signin"
            :config="config"></DesktopSignInMenu>
    </div>
</template>

<script lang="ts">
    export interface INavAuthMenuConfig {
        signIn: string;
        registerUrl: string;
    }

    export interface INavAuthMenuProps {
        config: INavAuthMenuConfig;
    }
</script>

<script setup lang="ts">
    import DesktopSignInMenu from "@eg_ui/src/components/globals/DesktopSignInMenu/DesktopSignInMenu.vue";

    const { config } = defineProps<INavAuthMenuProps>();
</script>

<style lang="scss">
    @use "./NavAuthMenu.scss";
</style>
